//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model

import blazern.lexisoup.graphql.model.adapter.ClientConfigQuery_ResponseAdapter
import blazern.lexisoup.graphql.model.selections.ClientConfigQuerySelections
import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.ExecutableDefinition
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import blazern.lexisoup.graphql.model.type.Query as CompiledQuery

public class ClientConfigQuery() : Query<ClientConfigQuery.Data> {
  override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  override fun hashCode(): Int = this::class.hashCode()

  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    // This operation doesn't have any variable
  }

  override fun adapter(): Adapter<Data> = ADAPTER

  override fun rootField(): CompiledField = ROOT_FIELD

  @ApolloAdaptableWith(ClientConfigQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val config: Config,
  ) : Query.Data

  public data class Config(
    public val backendRedirectionUrl: String?,
    public val minQueryLength: Int,
    public val maxQueryLength: Int,
    public val translateTextLengthMax: Int,
    public val translateTextLengthMin: Int,
    public val translateBatchSizeLimit: Int,
  )

  public companion object : ExecutableDefinition<Data> {
    override val ADAPTER: Adapter<Data> = ClientConfigQuery_ResponseAdapter.Data.obj()

    override val ROOT_FIELD: CompiledField = CompiledField.Builder(
          name = "data",
          type = CompiledQuery.type
        )
        .selections(selections = ClientConfigQuerySelections.__root)
        .build()

    public const val OPERATION_ID: String =
        "e80a21c24b02ce5110c7ef98532a6d1240f97776a5a2477b06c5c57e520a4855"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query ClientConfig {
     *   config {
     *     backendRedirectionUrl
     *     minQueryLength
     *     maxQueryLength
     *     translateTextLengthMax
     *     translateTextLengthMin
     *     translateBatchSizeLimit
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query ClientConfig { config { backendRedirectionUrl minQueryLength maxQueryLength translateTextLengthMax translateTextLengthMin translateBatchSizeLimit } }"

    public const val OPERATION_NAME: String = "ClientConfig"
  }
}
